import { destroyFile } from "@/helpers/commonHelper";
import { uploadFile } from "@/helpers/fileHelper";

export default {
  name: "FormFieldDialog",
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: true,
      editingField: null,
      validationOptions: [
        { text: "Keine", value: "" },
        { text: "Nicht leer", value: "required" },
        { text: "E-Mail", value: "email" },
        { text: "URL", value: "url" },
        { text: "Nur Zahlen", value: "number" },
        { text: "Muster (Regex)", value: "pattern" },
        { text: "Telefon", value: "phone" }
      ]
    };
  },
  computed: {
    hasOptions() {
      return ["select", "radio", "checkbox", "checkbox-image"].includes(
        this.editingField?.type
      );
    },
    hasImageOptions() {
      return this.editingField?.type === "checkbox-image";
    },
    hasMaxSelectionsOption() {
      return this.editingField?.type === "checkbox-image";
    },
    hasStepOption() {
      return this.editingField?.type === "number";
    },
    principalId() {
      return this.$store.state.selectedPrincipal?.id || "";
    }
  },
  watch: {
    field: {
      handler(newField) {
        this.editingField = JSON.parse(JSON.stringify(newField));
        if (typeof this.editingField.dontSend === "undefined") {
          this.editingField.dontSend = false;
        }
        if (typeof this.editingField.link === "undefined") {
          this.editingField.link = "";
        }
        // Stelle sicher, dass options ein Array ist
        if (!this.editingField.options) {
          this.editingField.options = [];
        }
        if (this.editingField.type === "checkbox-image") {
          this.editingField.options = this.editingField.options.map(option => ({
            label: option.label || "",
            value: option.value || "",
            image: option.image || null
          }));
          const maxSelections = Number(this.editingField.maxSelections);
          this.editingField.maxSelections =
            Number.isInteger(maxSelections) && maxSelections > 0
              ? maxSelections
              : null;
        }
        if (this.editingField.type === "number") {
          if (typeof this.editingField.step === "undefined") {
            this.editingField.step = 1;
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    getLabelFieldLabel() {
      if (this.editingField?.type === "link") {
        return "Linktext";
      }
      if (this.editingField?.type === "html") {
        return "HTML-Inhalt";
      }
      return "Feldname/Label";
    },
    getLabelFieldPlaceholder() {
      if (this.editingField?.type === "link") {
        return "z.B. Hier klicken";
      }
      if (this.editingField?.type === "html") {
        return "z.B. <h3>Überschrift</h3>";
      }
      return "z.B. Vorname";
    },
    getPlaceholderFieldLabel() {
      if (this.editingField?.type === "link") {
        return "URL";
      }
      if (this.editingField?.type === "html") {
        return "Nicht verwendet";
      }
      return "Platzhaltertext";
    },
    getPlaceholderFieldPlaceholder() {
      if (this.editingField?.type === "link") {
        return "z.B. https://example.com";
      }
      if (this.editingField?.type === "html") {
        return "Dieses Feld wird nicht verwendet";
      }
      return "z.B. Geben Sie Ihren Vornamen ein";
    },
    addOption() {
      if (!this.editingField.options) {
        this.editingField.options = [];
      }
      const option = {
        label: "",
        value: ""
      };
      if (this.hasImageOptions) {
        option.image = null;
      }
      this.editingField.options.push(option);
    },
    async removeOption(index) {
      const option = this.editingField.options[index];
      if (this.hasImageOptions && option?.image?.id) {
        await destroyFile("forms", option.image.id);
      }
      this.editingField.options.splice(index, 1);
    },
    getOptionImageUrl(option) {
      if (!option?.image) return "";
      return option.image.url || option.image;
    },
    async onOptionImageSelected(index, file) {
      if (!file || !this.principalId) return;
      try {
        const option = this.editingField.options[index];
        option.image = await uploadFile(
          file,
          this.editingField.id || "form-field",
          "forms",
          this.principalId
        );
      } catch (error) {
        console.error("Fehler beim Bild-Upload:", error);
        this.$snackbar("Bild konnte nicht hochgeladen werden", "error");
      }
    },
    async removeOptionImage(index) {
      const option = this.editingField.options[index];
      if (option?.image?.id) {
        await destroyFile("forms", option.image.id);
      }
      this.editingField.options[index].image = null;
    },
    save() {
      if (this.editingField?.type === "checkbox-image") {
        const maxSelections = Number(this.editingField.maxSelections);
        this.editingField.maxSelections =
          Number.isInteger(maxSelections) && maxSelections > 0
            ? maxSelections
            : null;
      }
      this.$emit("save", this.editingField);
      this.show = false;
    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
    }
  }
};
